var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIconConverter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "#FF5E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6C13.7835 6 13 6.7835 13 7.75V16.25C13 17.2165 13.7835 18 14.75 18C15.7165 18 16.5 17.2165 16.5 16.25V7.75C16.5 6.7835 15.7165 6 14.75 6Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 20C13.7835 20 13 20.7835 13 21.75C13 22.7165 13.7835 23.5 14.75 23.5C15.7165 23.5 16.5 22.7165 16.5 21.75C16.5 20.7835 15.7165 20 14.75 20Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconConverter);
export default __webpack_public_path__ + "static/media/error-icon-converter.de54b0b6f01f62e985e86dd8a7c0581b.svg";
export { ForwardRef as ReactComponent };